import React, { useState } from "react";

//libraries
import { Helmet } from "react-helmet-async";

//styles
import "./ServicesScreen.scss";

//images and content
import pt from "../../assets/pt.png";
import report from "../../assets/report.png";
import kettlebell from "../../assets/kettlebell.png";
import ptvert from "./ptvert.webp";
import ptcontent from "./ptcontent.js";

//image gallery
import img1 from "./GalleryPhotos/img1.webp";
import img2 from "./GalleryPhotos/img2.webp";
import img3 from "./GalleryPhotos/img3.webp";
import img4 from "./GalleryPhotos/img4.webp";
import img5 from "./GalleryPhotos/img5.webp";
import img6 from "./GalleryPhotos/img6.webp";
import img7 from "./GalleryPhotos/img7.webp";
import img8 from "./GalleryPhotos/img8.webp";
import img9 from "./GalleryPhotos/img9.webp";
import img10 from "./GalleryPhotos/img10.webp";
import img11 from "./GalleryPhotos/img11.webp";
import img12 from "./GalleryPhotos/img12.webp";
import img13 from "./GalleryPhotos/img13.webp";

//components
import ImageGallery from "./ImageGallery.jsx";
import CallButton from "../../components/DiscoveryButton/CallButton.jsx";
import IconContainer from "../../components/Icons/IconContainer.jsx";

const PTScreen = () => {
  const imageGallery = [
    img1,
    img2,
    img3,
    img4,
    img5,
    img6,
    img7,
    img8,
    img9,
    img10,
    img11,
    img12,
    img13,
  ];
  const [icons] = useState([
    { icon: report, alt: "clipboard icon" },
    { icon: pt, alt: "stretching icon" },
    { icon: kettlebell, alt: "weight icon" },
  ]);

  return (
    <>
      <Helmet>
        <title>
          Physical Therapy Services | Concierge Wellness Colorado Springs
        </title>

        <meta
          name="description"
          content="Comprehensive physical therapy in Colorado Springs focused on movement, recovery, and performance. Personalized treatment including manual therapy, corrective exercise, and movement-based rehabilitation to help you reduce pain and move better."
        />

        <link
          rel="canonical"
          href="https://conciergewellnesspt.com/physicaltherapy"
        />

        <meta
          property="og:title"
          content="Physical Therapy Services | Concierge Wellness"
        />

        <meta
          property="og:description"
          content="Personalized physical therapy in Colorado Springs designed to improve movement, reduce pain, and support long-term performance."
        />

        <meta
          property="og:url"
          content="https://conciergewellnesspt.com/physicaltherapy"
        />

        <meta property="og:type" content="website" />

        <meta
          property="og:image"
          content="https://conciergewellnesspt.com/icon.png"
        />
      </Helmet>
      <main className="services">
        <div
          className="services-container"
          data-aos="fade-up"
          data-aos-duration="1000"
        >
          {/* image and grey rectangle underneath */}
          <div className="image-container">
            <img
              className="main-photo"
              src={ptvert}
              alt="Dr. Wade helps a patient achieve proper form with a kettlebell exercise"
            />
            <div className="overlapping"></div>
          </div>

          {/* text of services screen */}
          <div className="services-main">
            <div className="services-background">
              <div className="services-text">
                <h1>{ptcontent.header}</h1>
                <h4>{ptcontent.subheading}</h4>
                <span className="hr-line"></span>

                {/* image placement for small screens */}
                <div className="small-screen-image-container">
                  <img
                    className="small-screen-photo"
                    src={ptvert}
                    alt="Dr. Wade helps a patient achieve proper form with a kettlebell exercise"
                  />
                </div>
                <p>{ptcontent.summary}</p>
                <div className="service-list">
                  <ul>
                    {ptcontent.listOne.map((service) => (
                      <li key={service}>{service}</li>
                    ))}
                  </ul>
                </div>
              </div>
              <span className="hr-line"></span>

              {/* three icons at the bottom of services text */}

              <div className="services-icons">
                {icons.map((icon) => (
                  <IconContainer icon={icon.icon} alt={icon.alt} />
                ))}
              </div>
            </div>
          </div>
        </div>
      </main>

      <ImageGallery images={imageGallery} />

      <div className="call-button-container">
        <CallButton />
      </div>
    </>
  );
};

export default PTScreen;
